package screens.static.settings

import common.ECssClasses
import components.Spacer.Spacer
import core.AppContext
import core.enums.EJSBridgeActions
import core.enums.ELocalizationKeys
import core.extensions.isInNativeApp
import core.extensions.postMessageToNativeApp
import core.extensions.toClassName
import core.io.dto.JSBridgeActionDTO
import core.ionic.EmptyProps
import core.ionic.IonRow
import core.ionic.IonToggle
import core.localStorage.LocalStorageDAO
import core.localization.Localization
import csstype.AlignItems
import csstype.px
import emotion.react.css
import kotlinx.browser.window
import react.FC
import react.dom.html.ReactHTML
import react.useContext
import react.useEffect
import react.useMemo

val UsageAnalysis = FC<EmptyProps> {

    val mContext by useContext(AppContext)

    val (mLocalStorageState, mLocalStorageDispatch) = mContext.mLocalStorageReducer

    val tracking = useMemo(mContext) {
        mContext.mLocalStorageReducer.component1().mSettingsObject?.mPiwikTrackingNativeActive
    }

    val isInNativeApp = window.isInNativeApp()

    useEffect(tracking) {
        if (isInNativeApp) {
            if (tracking == true) {
                val jsBridgeActionDTO = JSBridgeActionDTO(
                    EJSBridgeActions.ACTIVATE_TRACKING,
                    0
                )
                window.postMessageToNativeApp(jsBridgeActionDTO)
            } else {
                val jsBridgeActionDTO = JSBridgeActionDTO(
                    EJSBridgeActions.DEACTIVATE_TRACKING,
                    0
                )
                window.postMessageToNativeApp(jsBridgeActionDTO)
            }
        }
    }

    IonRow {
        css {
            alignItems = AlignItems.Companion.center
            marginLeft = 16.px
            marginRight = 16.px
        }
        ReactHTML.span {
            css(ECssClasses.LIST_HEADER_FONT.toClassName()) {
                marginLeft = 0.px
            }
            +Localization.getLocalizationKey(ELocalizationKeys.SETTINGS_USAGE_ANALYSIS_TITLE.name)
        }
        Spacer()
        IonToggle {
            checked = tracking ?: true
            onClick = {
                mLocalStorageDispatch.invoke(LocalStorageDAO.ELocalStorageAction.SET_PIWIK_NATIVE_TRACKING)
            }
        }
    }
    IonRow {
        css {
            marginLeft = 16.px
            marginRight = 16.px
        }
        ReactHTML.span {
            css(ECssClasses.BODY_FONT.toClassName()) {}
            +Localization.getLocalizationKey(ELocalizationKeys.USAGE_ANALYSIS_TEXT.name)
        }
    }
}